import React from 'react'
import dynamic from 'next/dynamic'
import { Container, Row, Col } from 'react-bootstrap'

import Error from '@shared/components/error'
import Layout from '@shared/components/layout'
import { useRouter } from 'next/router'
import { navLoader, pageLoading } from '@shared/libs/allLoader'
import { GET_TAG_ARTICLE, GET_RECENT_MATCH_PLAYER, FETCH_PLAYER_STATS } from '@graphql/tag/tag.query'
import { WIDGET } from '@shared-submodule/sm-constants'
import useWindowSize from '@shared/hooks/windowSize'
import { arraySortByOrder, parallelCalls } from '@shared-submodule/utils'
// import { googleAddData } from '@shared-submodule/sm-constants/googleAdsData'
// import { skyAddData } from '@shared/constants/skyAds'
import { ENUM_CRICKET_PLAYER_PAGES } from '@shared-submodule/sm-enum'
import { reviveAdData } from '@shared/components/reviveAds/reviveAdData'

// const GoogleAds = dynamic(() => import('@shared-submodule/sm-components/googleAds'), { ssr: false })
const PlayerHeader = dynamic(() => import('@shared/components/player/playerHeader'))
const PlayerOverview = dynamic(() => import('@shared/components/player/playerOverview'))
const CommonNav = dynamic(() => import('@shared/components/commonNav'), { loading: () => navLoader() })
const PlayerNews = dynamic(() => import('@shared/components/player/playerNews'), { loading: () => pageLoading() })
const PlayerMatch = dynamic(() => import('@shared/components/player/playerMatches'), { loading: () => pageLoading() })
const PlayerStats = dynamic(() => import('@shared/components/player/playerStats'), { loading: () => pageLoading() })
const AllWidget = dynamic(() => import('@shared/components/allWidget'), { ssr: false })
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })
const ReviveAds = dynamic(() => import('@shared/components/reviveAds'), { ssr: false })

function playerProfile({
  playerData,
  playerStatsData,
  article,
  seoData,
  fantasyArticle,
  tagData,
  recentFormData,
  odiData,
  t20Data,
  testData
}) {
  const router = useRouter()
  const [width] = useWindowSize()

  const subPages = playerData.oPlayerSeos?.oSeo
  function getNavItems() {
    const items = []
    subPages?.forEach(t => {
      if (ENUM_CRICKET_PLAYER_PAGES[t?.eSubType]) {
        items.push({
          navItem: ENUM_CRICKET_PLAYER_PAGES[t?.eSubType],
          url: `/${t?.sSlug}`,
          active: t?.eSubType === seoData?.eSubType
        })
      } else if (t?.eSubType === null) {
        // Home Tab
        items.push({
          navItem: ENUM_CRICKET_PLAYER_PAGES.o.replaceAll(/-/gi, ' '),
          url: `/${t?.sSlug}`,
          active: t?.eSubType === seoData?.eSubType
        })
      }
    })
    const order = ['overview', 'matches', 'stats', 'news']
    return arraySortByOrder({ data: items, order, key: 'navItem' })
  }

  const playerContent = () => {
    if (router?.asPath === `/${playerData?.oSeo?.sSlug}`) {
      return <PlayerOverview playerData={playerData} article={article} playerStatsData={playerStatsData} recentFormData={recentFormData} />
    } else if (router?.asPath === `/${playerData?.oSeo?.sSlug}/news`) {
      return <PlayerNews data={article} playerData={playerData} />
    } else if (router?.asPath === `/${playerData?.oSeo?.sSlug}/match`) {
      return <PlayerMatch playerData={playerData} odiData={odiData} t20Data={t20Data} testData={testData} />
    } else if (router?.asPath === `/${playerData?.oSeo?.sSlug}/stats`) {
      return <PlayerStats playerStatsData={playerStatsData} playerData={playerData} />
    }
  }
  if (router?.asPath === `/${playerData?.oSeo?.sSlug}/news`) {
    delete seoData?.sCUrl
  }
  const { addTop, mobSm, addBottom, addRight, addLeft } = reviveAdData
  return (
    <Layout data={{ oSeo: seoData }}>
      <ATSAds />
      <Container className="pt-3">
        <Row>
          <Col lg={9} className="left-content">
            <PlayerHeader data={playerData} key={playerData?._id} />
            <div className="w-full d-none d-xl-flex justify-content-center ">
                {/* <GoogleAds
                  addId={googleAddData?.addTop?.addId}
                  divId={googleAddData?.addTop?.divId}
                  dimension={googleAddData?.addTop?.dimension}
                  slotId={googleAddData?.addTop?.slotId}
                  className={'mt-4'}
                /> */}
                <ReviveAds {...addTop} className={'mt-4'}/>
              </div>
              <div className="w-full d-flex d-xl-none justify-content-center ">
                {/* <GoogleAds
                  addId={googleAddData?.mobSm?.addId}
                  divId={googleAddData?.mobSm?.divId}
                  dimension={googleAddData?.mobSm?.dimension}
                  slotId={googleAddData?.mobSm?.slotId}
                  className={'mt-4'}
                /> */}
                <ReviveAds {...mobSm} className={'mt-4'}/>
              </div>
            <CommonNav items={getNavItems()} />
            {playerContent()}
            {width > 1400 &&
            // <GoogleAds
            //       addId={skyAddData?.addBottom?.addId}
            //       divId={skyAddData?.addBottom?.divId}
            //       dimension={skyAddData?.addBottom?.dimension}
            //       slotId={skyAddData?.addBottom?.slotId}
            //       className={'my-3'}
            //     />
            <ReviveAds {...addBottom} className={'my-3 text-center'}/>
            }
             {width < 1000 &&
            // <GoogleAds
            //       addId={skyAddData?.addRight?.addId}
            //       divId={skyAddData?.addRight?.divId}
            //       dimension={skyAddData?.addRight?.dimension}
            //       slotId={skyAddData?.addRight?.slotId}
            //       className={'my-3'}
            //     />
            <ReviveAds {...addLeft} className={'d-flex justify-content-center my-3'}/>
            }
          </Col>
          {width > 991 && (
            <Col lg={3} className="common-sidebar">
              <AllWidget type={WIDGET.trendingNews} show />
              {/* <GoogleAds
                    addId={googleAddData?.addRight?.addId}
                    divId={googleAddData?.addRight?.divId}
                    dimension={googleAddData?.addRight?.dimension}
                    slotId={googleAddData?.addRight?.slotId}
                className={'mb-4 sticky_ads'}
                  /> */}
                <ReviveAds {...addRight} className={'d-flex justify-content-center mb-4 sticky_ads'}/>
            </Col>
          )}
        </Row>
      </Container>
    </Layout>
  )
}

export default Error(playerProfile)

export async function getServerSideProps({ req, res, params, query, resolvedUrl }) {
  const { checkPageNumberInSlug } = await import('@shared-submodule/utils')
  const { slug, secondLast, lastSlug } = checkPageNumberInSlug([...params?.slug], false)
  try {
    const queryGraphql = (await import('@shared/components/queryGraphql')).default
    const { checkRedirectionStatus } = await import('@shared-submodule/utils')
    const GET_SEO_DATA = (await import('@graphql/article/article.query')).GET_SEO_DATA
    const { data: seo } = await queryGraphql(GET_SEO_DATA, { input: { sSlug: `cricket/players/${slug?.join('/')}` } })

    // Check Redirection
    const { redirectStatus, eCode, returnObj, props } = checkRedirectionStatus(seo?.getSeoData)
    if (redirectStatus && props) {
      res.statusCode = eCode
      return { props }
    } else if (redirectStatus) return returnObj
    if (seo?.getSeoData?.eType === 'p' && seo?.getSeoData?.eStatus === 'a') {
      res.setHeader('Cache-Control', 'public, max-age=420')
      const GET_PLAYER_BY_ID = (await import('@graphql/tag/tag.query')).GET_PLAYER_BY_ID

      const [playerData] = await parallelCalls([queryGraphql(GET_PLAYER_BY_ID, { input: { _id: seo?.getSeoData?.iId } })])
      const query = []
      if (playerData?.getPlayerByIdFront?.eTagStatus === 'a' && (lastSlug === 'stats' || !secondLast)) {
        query.push(queryGraphql(FETCH_PLAYER_STATS, { input: { iPlayerId: playerData?.getPlayerByIdFront?._id } }))
        // query.push(
        //   queryGraphql(GET_TAG_ARTICLE, {
        //     input: { _id: seo?.getSeoData?.iId, eType: seo?.getSeoData?.eType, nLimit: 6, nSkip: 0, sSortBy: 'dCreated', nOrder: -1 }
        //   })
        // )
      }

      if (playerData?.getPlayerByIdFront?.eTagStatus === 'a' && lastSlug === 'news') {
        query.push(
          queryGraphql(GET_TAG_ARTICLE, {
            input: {
              _id: seo?.getSeoData?.iId,
              eType: seo?.getSeoData?.eType,
              nLimit: 16,
              nSkip: 0,
              sSortBy: 'dCreated',
              nOrder: -1
            }
          })
        )
        const [article] = await parallelCalls(query)
        return {
          props: {
            seoData: seo?.getSeoData,
            playerData: playerData?.getPlayerByIdFront,
            // playerStatsData: playerStatsData?.fetchPlayerStats,
            article: article?.getTagArticlesFront
          }
        }
      } else if (playerData?.getPlayerByIdFront?.eTagStatus === 'a' && lastSlug === 'match') {
        const [odiData, t20Data, testData] = await parallelCalls([
          queryGraphql(GET_RECENT_MATCH_PLAYER, { input: { _id: seo?.getSeoData?.iId, nLimit: 5, aFormatStr: 'odi' } }),
          queryGraphql(GET_RECENT_MATCH_PLAYER, { input: { _id: seo?.getSeoData?.iId, nLimit: 5, aFormatStr: 't20' } }),
          queryGraphql(GET_RECENT_MATCH_PLAYER, { input: { _id: seo?.getSeoData?.iId, nLimit: 5, aFormatStr: 'test' } })
        ])

        return {
          props: {
            seoData: seo?.getSeoData,
            playerData: playerData?.getPlayerByIdFront,
            odiData: odiData?.getRecentMatchesOfPlayer,
            t20Data: t20Data?.getRecentMatchesOfPlayer,
            testData: testData?.getRecentMatchesOfPlayer
          }
        }
      } else if (playerData?.getPlayerByIdFront?.eTagStatus === 'a' && lastSlug === 'stats') {
        const [playerStatsData] = await parallelCalls(query)
        return {
          props: {
            seoData: seo?.getSeoData,
            playerData: playerData?.getPlayerByIdFront,
            playerStatsData: playerStatsData?.fetchPlayerStats
          }
        }
      } else if (playerData?.getPlayerByIdFront?.eTagStatus === 'a' && !secondLast) {
        query.push(
          queryGraphql(GET_TAG_ARTICLE, {
            input: { _id: seo?.getSeoData?.iId, eType: seo?.getSeoData?.eType, nLimit: 6, nSkip: 0, sSortBy: 'dCreated', nOrder: -1 }
          }),
          queryGraphql(GET_RECENT_MATCH_PLAYER, { input: { _id: seo?.getSeoData?.iId, nLimit: 5, aFormatStr: 'all' } })
        )
        const [playerStatsData, article, recentFormData] = await parallelCalls(query)
        return {
          props: {
            seoData: seo?.getSeoData,
            playerData: playerData?.getPlayerByIdFront,
            playerStatsData: playerStatsData?.fetchPlayerStats,
            article: article?.getTagArticlesFront,
            recentFormData: recentFormData?.getRecentMatchesOfPlayer
          }
        }
      } else {
        return {
          notFound: true
        }
      }
    } else {
      return {
        notFound: true
      }
    }
  } catch (e) {
    console.log({ e })
    res.setHeader('Cache-Control', 'no-cache')
    const handleApiError = (await import('@shared-submodule/utils')).handleApiError
    const status = handleApiError(e, resolvedUrl)
    return status
  }
}
